var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    className: "cls-1",
    d: "M9.78,2.3H3.72c-.78,0-1.41.63-1.41,1.41v3.63c0,.78.63,1.41,1.41,1.42h6.06c.78,0,1.41-.63,1.41-1.42v-3.63c0-.78-.63-1.41-1.41-1.41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    className: "cls-1",
    d: "M9.78,10.38H3.72c-.78,0-1.41.63-1.41,1.41v8.48c0,.78.63,1.41,1.41,1.41h6.06c.78,0,1.41-.63,1.41-1.41v-8.48c0-.78-.63-1.41-1.41-1.41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    className: "cls-1",
    d: "M20.28,15.23h-6.06c-.78,0-1.41.63-1.41,1.41v3.64c0,.78.63,1.41,1.41,1.41h6.06c.78,0,1.41-.63,1.41-1.41v-3.64c0-.78-.63-1.41-1.41-1.41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    className: "cls-1",
    d: "M20.28,2.3h-6.06c-.78,0-1.41.63-1.41,1.41v8.49c0,.78.63,1.41,1.41,1.41h6.06c.78,0,1.41-.63,1.41-1.41V3.72c0-.78-.63-1.41-1.41-1.41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.2514bdc1cf2642019b561924bc21a18b.svg";
export { ForwardRef as ReactComponent };